export default __webpack_public_path__ + "static/media/img-office.e24499a8.jpg";